import type { MarketplaceType } from '@/common/api/client/types.gen'

export const MARKETPLACE_OAUTH_MESSAGE_SUCCESS = 'pixorion:marketplace-oauth:success' as const
export const MARKETPLACE_OAUTH_MESSAGE_ERROR = 'pixorion:marketplace-oauth:error' as const

export const MARKETPLACE_OAUTH_MODAL_ID = 'marketplace-oauth-modal'
export const MARKETPLACE_OAUTH_POPUP_NAME = 'pixorion_marketplace_oauth'

export const INTEGRATIONS_PAGE_PATH = '/app/profile/integrations'

export type MarketplaceOauthSuccessMessage = {
    type: typeof MARKETPLACE_OAUTH_MESSAGE_SUCCESS
    sellerId?: string
    integrationId?: string
}

export type MarketplaceOauthErrorMessage = {
    type: typeof MARKETPLACE_OAUTH_MESSAGE_ERROR
    error?: string
}

export type MarketplaceOauthMessage = MarketplaceOauthSuccessMessage | MarketplaceOauthErrorMessage

const getAllowedMessageOrigin = (): string => {
    try {
        return new URL(__ENDPOINTS_HOST__).origin
    } catch {
        return ''
    }
}

export const getCreateMarketplaceOauthUrl = (orgId: string, marketplace: MarketplaceType): string => {
    const url = new URL(`${__ENDPOINTS_HOST__}/api/v1/organizations/${orgId}/marketplace-oauth-integrations`)
    url.searchParams.set('marketplace', marketplace)
    return url.toString()
}

export const getUpdateMarketplaceOauthUrl = (orgId: string, integrationId: string): string =>
    `${__ENDPOINTS_HOST__}/api/v1/organizations/${orgId}/marketplace-oauth-integrations/${integrationId}`

export const getMarketplaceOauthUrl = (orgId: string, marketplace: MarketplaceType, integrationId?: string): string => {
    if (integrationId) {
        return getUpdateMarketplaceOauthUrl(orgId, integrationId)
    }
    return getCreateMarketplaceOauthUrl(orgId, marketplace)
}

export const openMarketplaceOauthModal = (): void => {
    const checkbox = document.getElementById(MARKETPLACE_OAUTH_MODAL_ID) as HTMLInputElement | null
    if (checkbox) {
        checkbox.checked = true
    }
}

export const closeMarketplaceOauthModal = (): void => {
    const checkbox = document.getElementById(MARKETPLACE_OAUTH_MODAL_ID) as HTMLInputElement | null
    if (checkbox) {
        checkbox.checked = false
    }
}

export const closeIntegrationModal = (modalId: string): void => {
    const checkbox = document.getElementById(modalId) as HTMLInputElement | null
    if (checkbox) {
        checkbox.checked = false
    }
}

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null

export const parseMarketplaceOauthMessage = (event: MessageEvent): MarketplaceOauthMessage | null => {
    const allowedOrigin = getAllowedMessageOrigin()
    if (!allowedOrigin || event.origin !== allowedOrigin) {
        return null
    }

    if (!isRecord(event.data) || typeof event.data.type !== 'string') {
        return null
    }

    if (event.data.type === MARKETPLACE_OAUTH_MESSAGE_SUCCESS) {
        return {
            type: MARKETPLACE_OAUTH_MESSAGE_SUCCESS,
            sellerId: typeof event.data.seller_id === 'string' ? event.data.seller_id : undefined,
            integrationId: typeof event.data.integration_id === 'string' ? event.data.integration_id : undefined,
        }
    }

    if (event.data.type === MARKETPLACE_OAUTH_MESSAGE_ERROR) {
        return {
            type: MARKETPLACE_OAUTH_MESSAGE_ERROR,
            error: typeof event.data.error === 'string' ? event.data.error : undefined,
        }
    }

    return null
}
